/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { baseRequest } from 'id-api/baseRequest';

let CLIENT_APP_CONFIG: Identity.API.ClientAppConfig;

export const getClientAppConfig = async (clientAppId: string): Promise<Identity.API.ClientAppConfig> => {
  if (clientAppId !== CLIENT_APP_CONFIG?.clientAppId) {
    await loadClientAppConfig(clientAppId);
  }
  return CLIENT_APP_CONFIG;
};

const loadClientAppConfig = async (clientAppId: string): Promise<void> => {
  const { data } = await baseRequest.get(`/client-app-config/${clientAppId}`);
  CLIENT_APP_CONFIG = data;
};

// todo: this will be needed to as part of mocking this lib (PLATPRODS-3910)
